export default __webpack_public_path__ + "static/1-1bea20aa552d3240b913845755de6087.jpeg";